import { Paper, PasswordInput, Stack } from "@mantine/core";
import { profileApi } from "apis/profileApi";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { ChangePasswordRequest } from "constants/types/profile";
import { useFormik } from "formik";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import { changePasswordValidationSchema } from "./config";

export const CHANGE_PASSWORD_FORM_ID = "change-password-form";

interface ChangePasswordModalProps {
  onClose?: () => void;
}

const ChangePasswordModal: FC<ChangePasswordModalProps> = ({ onClose }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik<ChangePasswordRequest>({
    initialValues: {
      currentPassword: "",
      newPassword: "",
    },
    validationSchema: changePasswordValidationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const res = await profileApi.changePassword(values);
        if (res.data.success) {
          notification.success({ title: "Đổi mật khẩu thành công" });
          formik.resetForm();
          onClose?.();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({
          title: "Đổi mật khẩu thất bại",
          message: error?.error?.message,
        });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Paper>
        <form id={CHANGE_PASSWORD_FORM_ID} onSubmit={formik.handleSubmit}>
          <Stack gap="sm">
            <PasswordInput
              label="Mật khẩu hiện tại"
              placeholder="Nhập mật khẩu hiện tại"
              name="currentPassword"
              value={formik.values.currentPassword}
              onChange={formik.handleChange}
              error={formik.errors.currentPassword}
            />
            <PasswordInput
              label="Mật khẩu mới"
              placeholder="Nhập mật khẩu mới"
              name="newPassword"
              value={formik.values.newPassword}
              onChange={formik.handleChange}
              error={formik.errors.newPassword}
            />
          </Stack>
        </form>
      </Paper>
    </Loading>
  );
};

export default ChangePasswordModal;
